import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
@Component({
  selector: 'app-cheque-no',
  templateUrl: './../../../templates/forms/modals/dept-name-list-transfer.component.html',
})
export class DeptNameListTransferComponent implements OnInit {
  @Input()
  config:any;

  @Input()
  modalShow: boolean = true;

  @Input()
  periodNo:string = "";

  @Input()
  accNo:string = "";

  @Input()
  buNo:string = "";

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  searchFields: any[] = ['BU_NAME_TR','BU_NO_TR'];
  public searchString;

  dataObj:any;

  deptNameList: any[] = [];


  constructor(public langService: LangService, private comService: CommonService) {

  }
  ngOnInit() {
    this.comService.getTransferDept(this.periodNo, this.accNo, this.buNo).subscribe(result => {
      this.deptNameList = result.body;
    })
  }

}
